import { responseUpdateRegionTax } from 'reactRedux/slices/regionEditSlice/RegionEditslice';
import { requestUpdateRegionTax } from 'reactRedux/slices/regionEditSlice/RegionEditslice';
import { failureUpdateRegionTax } from 'reactRedux/slices/regionEditSlice/RegionEditslice';
import {
  failureGetRegion,
  responseGetRegion,
  requestGetRegion,
} from 'reactRedux/slices/regionEditSlice/RegionEditslice';
import {
  requestAddRegion,
  responseAddRegion,
  failureAddRegion,
} from 'reactRedux/slices/regionEditSlice/RegionEditslice';
import Swal from 'sweetalert2';
import requestApi from 'utils/Request';
import { REGION } from 'utils/StaticApiEndpoints';

//// Region Get Data ////
export const GetLoginUserRegionData = () => async (dispatch) => {
  try {
    dispatch(requestGetRegion());
    const { data } = await requestApi.get(`${REGION}`);
    dispatch(responseGetRegion(data));
  } catch (error) {
    Swal.fire({
      icon: 'error',
      text: error?.message,
    });
    dispatch(failureGetRegion(error?.message));
  }
};

////////////////////// edit region tax data ///////////////////
export const EditRegionTaxData = (payload, callback) => async (dispatch) => {
  try {
    dispatch(requestUpdateRegionTax());
    const res = await requestApi.put(`${REGION}`, payload);
    dispatch(responseUpdateRegionTax(res));
    if (typeof callback === 'function') {
      callback();
    }
  } catch (error) {
    Swal.fire({
      icon: 'error',
      text: error?.message,
    });
    dispatch(failureUpdateRegionTax(error?.message));
  }
};

////////////////////// add region data ///////////////////
export const AddRegionData = (payload, callback) => async (dispatch) => {
  try {
    dispatch(requestAddRegion());
    const res = await requestApi.post(`${REGION}`, payload);
    dispatch(responseAddRegion(res));
    Swal.fire({
      icon: 'success',
      text: 'Region added successfully!',
      timer: 1500,
      showConfirmButton: false,
    });
    if (typeof callback === 'function') {
      callback();
    }
  } catch (error) {
    Swal.fire({
      icon: 'error',
      text: error?.message,
    });
    dispatch(failureAddRegion(error?.message));
  }
};
